module.exports = __webpack_public_path__ + "img/symbol_12.c8f73b69.png";